/**
 * If redirection in IIS is correctly setup. Redirection is made by WELS Operator by WELS Schema, welsws_pkg.print_app_front_page.
 * Then initOperatorsDirectPage is the only entry point, as operators_direct is the only entrypoint.
 *
 * If redirection in IIS is NOT correctly setup. Fallback is static pages index.html and operators.html.
 *
 * This module has responsibility to
 * - Check if localstorage is available (should be in all modern browsers).
 * - Check if 'WELS_deck_data' and 'WELS_vessel_data' is set in the localstorage, meaning someone allready is logged in.
 *
 */
var VRC = VRC || {};
VRC.RedirectModule = (function(){

	/**
	 * Initializes the index.html
	 */
	var initIndexPage = function(){
		if(!localStorage) {
			handleNoLocalStorage();
			return;
		}
		if( hasLoginInformation() ){
			redirectToApplication();
		}
	};

	/**
	 * Initializes the operators.html
	 */
	var initOperatorsPage = function(){
		if(!localStorage) {
			handleNoLocalStorage();
			return;
		}
		if( hasLoginInformation() ){
			redirectToApplication();
		}
		var operator = getURLParameter('v') || 'no';
		$('.operator_selection_area__'+operator).show();
	};

	/**
	 * Initializes the operators_direct.html
	 * Used to set URL parameters ('v') and ('o') for set the operator and 'user_param' to local storage.
	*/
	var initOperatorsDirectPage = function() {
		var valuev = getURLParameter('v');
		var valueopr = getURLParameter('o');

		if (valueopr !== undefined && valuev !== undefined) {
			localStorage['login_operator_param'] = valueopr;
			localStorage['login_user_param'] = valuev;
			redirectToApplication();
		}
	}

	/**
	 * Check if 'WELS_deck_data' and 'WELS_vessel_data' is set in locale storage, meaning that the vessel is logged in then.
	 * @returns {boolean} Is already logged in.
	 */
	var hasLoginInformation = function(){
			return localStorage['WELS_deck_data'] !== undefined && localStorage['WELS_vessel_data'] !== undefined;
	};

	/**
	 * Redirects to the actual application, which (for some legacy reason) is at deckstate.html
	 */
	var redirectToApplication = function(){
		document.location = "deckstate.html";
	};

	/**
	 * Used by operator.html with OnClick
	 * Selects the operator ('BPN', 'BPUK' etc.) and user_param (always 'vessel' maybe thinking this could be expanded in the future);
	 * @param operator
	 */
	var selectOperator = function(operator) {
		localStorage['login_operator_param'] = operator;
		localStorage['login_user_param'] = 'vessel';
		redirectToApplication();
	};

	/**
	 * Prints out alert if localstorage is not implemented in the browser.
	 */
	var handleNoLocalStorage = function(){
		alert( 'Your browser does not support HTML5 localStorage. Can not save or load local state' );;
	};

	/**
	 * Get parameter from URL
	 * @param name parameterName
	 * @returns {string} parameterValue
	 */
	var getURLParameter = function(name) {
		return decodeURIComponent(
			(location.search.match(RegExp("[?|&]"+name+'=(.+?)(&|$)'))||[,null])[1]
		);
	};

	/**
	 * Set the country parameter for the operators.html.
	 * @param type country ('no', 'dk', 'us')
	 */
	var selectCountry = function( type ) {
		document.location.replace("operators.html?v=" + type );
	};

	return{
		initIndexPage : initIndexPage,
		initOperatorsPage : initOperatorsPage,
		initOperatorsDirectPage : initOperatorsDirectPage,
		selectOperator : selectOperator,
		selectCountry : selectCountry,
		getURLParameter : getURLParameter
	}
})();



